module.exports = __webpack_public_path__ + "europa-200_portrait_window.jpg?c95923f7d0b5888213bb3d9f4374f9ff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-200_portrait_window.jpg
// module id = 323
// module chunks = 0